import { useUnit } from 'effector-react'
import { $tickets, $totalCountOfTickets, getTicketsFx } from './model'

export const useTicketsList = () => {
  const tickets = useUnit($tickets)
  const totalCountOfTickets = useUnit($totalCountOfTickets)
  const loading = useUnit(getTicketsFx.pending)

  return { tickets, totalCountOfTickets, loading }
}
